export const PATH = {
  OVERVIEW: 'overview',
  EDIT: 'edit',
  LANGUAGE: 'language',
}

export const profileLinks = {
  profileOverviewLink: () => `/${PATH.OVERVIEW}`,
  profileEditLink: () => `/${PATH.EDIT}`,
  profileLanguageLink: () => `/${PATH.LANGUAGE}`,
}
